/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

const LINK_ROUTE_MAP = {
  campaign: 'campaigns.campaign',
  newsletter: 'broadcasts.newsletter',
  apitb: 'broadcasts.broadcast',
};

interface MessagingLimitCountItemArgs {
  item: {
    // eslint-disable-next-line spellcheck/spell-checker
    type: 'campaign' | 'newsletter' | 'apitb';
  };
}

export default class MessagingLimitCountItem extends Component<MessagingLimitCountItemArgs> {
  get itemLinkRoute() {
    return LINK_ROUTE_MAP[this.args.item.type];
  }
}
